import { ErrorType, IConfirmationApiRequest } from '../../shared/types';
import { Confirmation } from '../contracts';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import { createAxiosConfig } from '../createAxiosConfig';
import { LogCannon } from '@ace-clublabs/log-cannon';
export const ConfirmationApi =
  (endpoint: string): Confirmation =>
  async (request: IConfirmationApiRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');

      const { data } = await axios.post(endpoint, request, createAxiosConfig(scenario, endpoint));
      return Promise.resolve(data);
    } catch (error: any) {
      LogCannon.error('ConfirmationApi error', error);
      const message = error?.message;
      return Promise.reject({ message, type: ErrorType.SYSTEM_ERROR });
    }
  };
